<template>
  <div class="prompts" v-show="Show" @click="close">
    <img src="~@/assets/images/url-app.png" />
    <p>{{ text }}</p>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: '点击右上角，分享给好友'
    }
  },
  data() {
    return {
      Show: this.show
    }
  },
  watch: {
    show(newV) {
      this.Show = newV
    }
  },
  computed: {},
  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="less">
@import '~@/assets/styles/global.less';
.prompts {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.5);
  p {
    color: #fff;
    font-size: 40 / @r;
    text-align: center;
    margin: 0;
  }
  img {
    width: 97%;
    margin: auto;
  }
}
</style>
